import { render, staticRenderFns } from "./activeOrders.vue?vue&type=template&id=6fbcd680&scoped=true&"
import script from "./activeOrders.vue?vue&type=script&lang=js&"
export * from "./activeOrders.vue?vue&type=script&lang=js&"
import style0 from "./activeOrders.vue?vue&type=style&index=0&id=6fbcd680&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fbcd680",
  null
  
)

export default component.exports